<template>
  <div>
    <div :class="['room', nRooms > 1 && stayChanged ? 'room--selected' : '']">
      <div :class="expanded && 'room__card'">
        <RoomCard
          :room="room"
          :expanded="expanded"
          :hotelCode="hotelCode"
          :hotelName="hotelName"
          :isLastRoomTab="isLastRoomTab"
          :currentRoom="currentRoom"
          :rooms="rooms"
          @roomSelected="handleRoomSelected"
          :remainingRooms="remainingRooms"
        />
      </div>

      <div v-if="expanded && currentRoom === 1">
        <RoomGroupsList
          class="room__stays"
          :room="room"
          :defaultTab="getDefaultTab"
          :bookingStayInProgress="bookingStayInProgress"
          :loyaltyConsentAccepted="loyaltyConsentAccepted"
          @selectStay="handleStayChange"
          :isLastRoomTab="isLastRoomTab"
          :currentRoom="currentRoom"
          :rooms="rooms"
          @roomSelected="handleRoomSelected"
        />
      </div>
    </div>
    <div v-if="currentRoom === 1" @click="scroll()" class="room__show-rates">
      <span class="room__show-rates-button text-12">{{
        expanded ? translate('rdHideAllRates') : translate('rdShowAllRates')
      }}</span>
    </div>
  </div>
</template>

<script>
import Room from '../../domain/Room'
import Customer from '../../../domain/Customer'
import Stay from '../../domain/Stay'
import TabTypes from '@/domain/TabTypes'
import RoomCard from '@/multi-room-display/components/room/RoomCard'
import RoomGroupsList from '@/multi-room-display/components/room/RoomGroupsList'
import { getQueryParams } from '@/infrastructure/Utils'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters, mapState } = createNamespacedHelpers('multiRoomDisplay')

export default {
  name: 'RoomComponent',
  components: { RoomGroupsList, RoomCard },
  props: {
    taxIncludedRegion: {
      type: Boolean,
      defaultValue: false
    },
    room: {
      type: Room
    },
    rooms: {
      type: Array
    },
    customer: {
      type: Customer
    },
    bookingStayInProgress: {
      type: Stay
    },
    loyaltyConsentAccepted: {
      type: Boolean
    },
    isLastRoomTab: {
      type: Boolean
    },
    currentRoom: {
      type: Number
    },
    isFirstRoom: {
      type: Boolean,
      defaultValue: false
    },
    nRooms: {
      type: Number
    },
    hotelCode: String,
    hotelName: String,
    remainingRooms: Number
  },
  data: () => ({
    expanded: true,
    scrollPosition: 0,
    queryParams: null,
    morOption: false,
    searchLowest: true,
    stayChanged: false,
    currentStayCode: ''
  }),
  created() {
    this.queryParams = getQueryParams(window.location.search)
    this.morOption = !!Object.keys(this.queryParams).find(key => key.includes('filter.member-only'))
    this.searchLowest = this.queryParams.searchType === 'lowest'
  },
  mounted() {
    const currentIndex = this.currentRoom - 1
    this.$nextTick(() => {
      this.stayChanged =
        this.rooms[currentIndex] && this.rooms[currentIndex]?.code === this.room?.id
      const stayCodeArray = this.rooms[currentIndex]?.rates[0]?.id?.split('|')
      this.currentStayCode = stayCodeArray?.[stayCodeArray.length - 2]
    })
  },
  computed: {
    ...mapGetters(['filter']),
    ...mapState(['selectedId']),
    hasFilter() {
      return this.filter.hasAnySelection(this.isFirstRoom)
    },
    getDefaultTab() {
      return TabTypes.MEMBER
    }
  },
  methods: {
    scroll() {
      if (!this.expanded) {
        this.scrollPosition = window.scrollY
      }
      this.expanded = !this.expanded
      process.nextTick(() => {
        window.scrollTo(0, this.scrollPosition)
      })
    },
    hasTaxIncluded() {
      return this.room.hasTaxIncluded() || this.taxIncludedRegion
    },
    handleStayChange(stay) {
      const currentIndex = this.currentRoom - 1
      if (currentIndex === 0 && stay?.code === this.currentStayCode) {
        this.$nextTick(() => {
          this.stayChanged = stay?.id === this.selectedId
        })
      }
    },
    handleRoomSelected(
      roomSelected,
      rates,
      code,
      mealPlan,
      rate,
      mealPlanName,
      rateName,
      dealOfTheDay
    ) {
      if (roomSelected) {
        this.$emit(
          'roomSelected',
          true,
          rates,
          code,
          mealPlan,
          rate,
          mealPlanName,
          rateName,
          dealOfTheDay
        )
      }
    }
  },
  watch: {
    hasFilter() {
      this.expanded = true
    }
  }
}
</script>

<style lang="scss" scoped>
.room {
  border: solid 1px #cccccc;

  @media (min-width: 992px) {
    border-radius: 0.5rem;
  }

  &--selected {
    border: 2px solid #000000;
  }

  &__card {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  &__show-rates {
    display: flex;
    justify-content: center;
    background-color: #cecece;
    margin: auto;
    border-radius: 0 0 0.5rem 0.5rem;
    cursor: pointer;
    @media (min-width: 992px) {
      width: 50%;
      border-radius: 0 0 5rem 5rem;
    }
  }

  &__show-rates-button {
    font-weight: bold;
    padding: 0 1rem;
    color: #53565a;
    cursor: pointer;
  }

  &__additional-taxes {
    padding-top: 3rem;
    padding-bottom: 1rem;
    font-size: 1rem;
    text-align: center;
    line-height: 1.5rem;
  }
}
</style>
